/**
 * DispatchIntelligenceRoute — skin-aware switcher for /dispatch-intelligence.
 *
 * Cockpit  → renders the unified SchedulingDispatchCockpit on the
 *            "intelligence" lens (same surface as /scheduling and
 *            /scheduling-dispatch).
 * Classic  → renders the original DispatchIntelligence page, untouched.
 */
import { useUISkin } from "@/data/UISkinContext";
import DispatchIntelligence from "./DispatchIntelligence";
import SchedulingDispatchCockpit from "@/components/dashboards/SchedulingDispatchCockpit";

export default function DispatchIntelligenceRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <SchedulingDispatchCockpit />;
  return <DispatchIntelligence />;
}
